import { getSiteCodeApi, siteListApi, separateSiteListApi, siteConfigApi, siteConfigSeparateApi } from '@/api/common/site'
import { getUrlKey, getBrowserDefaultLang, langIsBelong, isFromTawian } from '@/utils'
import { getDictionaryApi } from '@/api/common/public'
import store from '@/store/index'
import i18n from '@/lang'
import { isOS, ESG_THACSP_CORE_OS, isId, isVn, isTh, SystemCodeUseNewConfigApi } from '@/utils/constant'
import { siteConfigExtend } from '../../api/common/site'
const state = {
  siteCode: '', // 根据ip获取用户所在的国家编码
  siteList: [], // 国家列表
  language: getUrlKey('lang') || '', // 语言编码
  langName: '', // 语言名称
  // 国家配置信息
  siteConfig: {
    code: '', // 注册登陆配置编码
    name: '', // 注册登陆配置名称
    countryName: '', // 国家名称
    country: '', // 国家编码
    langDefault: { // 默认语言
      lang: '', // 语言编码
      langName: '' // 语言名（i18n）
    },
    langs: [], // 站点支持的语种列表
    loginConfig: { // 默认初始化全部为true，接口报错时，全部显示
      personalEnable: true, // 是否允许个人登陆
      personal: {
        mobileEnable: true, // 个人是否允许手机号码登陆
        emailEnable: true, // 个人是否允许email登陆
        usernameEnable: true, // 个人是否允许用户名登陆
        wxEnable: true // 个人是否允许微信登录登陆
      },
      enterpriseEnable: true, // 是否允许企业登陆
      enterprise: {
        mobileEnable: true, // 企业是否允许手机号码登陆
        emailEnable: true, // 企业是否允许email登陆
        usernameEnable: true, // 企业是否允许用户名登陆
        wxEnable: true // 个人是否允许微信登录登陆
      }
    },
    registConfig: { // 默认初始化全部为true，接口报错时，全部显示
      // 允许个人注册时的相关配置
      personalEnable: true, // 是否允许个人注册
      personal: {
        mobileEnable: true, // 是否允许手机号注册
        mobileCountries: [], // 个人注册国家区号列表
        emailEnable: true // 是否允许邮箱注册
      },
      enterpriseEnable: true, // 是否允许企业注册
      enterprise: {
        mobileEnable: true, // 是否允许手机号注册
        mobileCountries: [], // 企业注册国家区号列表
        emailEnable: true // 是否允许邮箱注册
      }
    }
  },
  regexpRemote: {},
  showMessageNotice: false,
  messageNoticeData: {
    show: false,
    phoneNumber: '',
    email: '',
    promotionSmsFlag: null,
    promotionEmailFlag: null,
    cb: () => {}
  },
  enableGeneratedPasswordCountry: [],
  siteConfigDone: false,

}

const mutations = {
  SET_SITE_CONFIG: (state, siteConfig) => {
    state.siteConfig = siteConfig
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
  },
  SET_LANG_NAME: (state, langName) => {
    state.langName = langName
  },
  SET_SITE_CODE: (state, siteCode) => {
    state.siteCode = siteCode
  },
  SET_SITE_LIST: (state, siteList) => {
    state.siteList = siteList
  },
  SET_REGEXP_REMOTE: (state, regexpRemote) => {
    state.regexpRemote = regexpRemote
  },
  SET_MESSAGE_NOTICE_SHOW(state, data) {
    state.showMessageNotice = data
  },
  SET_MESSAGE_NOTICE_DATA: (state, data) => {
    if (!state.showMessageNotice || isOS()) {
      data.cb()
      return
    }
    const { emailSensitization, phoneNumberSensitization, promotionSmsFlag, promotionEmailFlag } = data.data
    const loginDirectly = !((emailSensitization && promotionEmailFlag === null) || (phoneNumberSensitization && promotionSmsFlag === null))
    if (loginDirectly) {
      data.cb()
      return
    }
    state.messageNoticeData = {
      show: data.show,
      cb: data.cb,
      emailSensitization: data.data.emailSensitization,
      phoneNumberSensitization: data.data.phoneNumberSensitization,
      promotionSmsFlag: true,
      promotionEmailFlag: true,
      tmpToken: data.data.tmpToken
    }
  },
  SET_MESSAGE_NOTICE_DATA_INDATA: (state, data) => {
    state.messageNoticeData = {
      ...state.messageNoticeData,
      ...data
    }
  },

  SET_GENERATED_PASSWORD_ENABLED(state, data) {
    state.enableGeneratedPasswordCountry = data
  },
  SET_SITE_CONFIG_DONE: (state, siteConfigDone) => {
    state.siteConfigDone = siteConfigDone
  },
  siteConfigExtend: (state, data) => {
    state.uiConfig = {
      ...state.uiConfig,
      ...data
    }
  }
}

const actions = {
  // 全局设置国家状态码
  // lzb 默认值也会走这里
  async siteCode({ rootState, commit, dispatch }) {
    try {
      // 1.语言会优先从本地临时缓存拿，页面刷新缓存消失

      // 2.没有从url拿

      // 3.再没有就请求后端，根据ip拿
      let country = rootState.site.siteConfig.country || getUrlKey('siteCountryCode') || null
      let langDefault = rootState.site.language || getUrlKey('lang') || null
      console.log('result is', country, langDefault)
      if (langIsBelong()) {
        if (getBrowserDefaultLang() === 'ja') {
          country = 'JP'
          langDefault = 'ja-JP'
        } else if (getBrowserDefaultLang() === 'ko') {
          country = 'KR'
          langDefault = 'ko-KR'
        }
      } else if (isId()) {
        country = 'ID'
        langDefault = 'id-ID'
      } else if (isVn()) {
        country = 'VN'
        langDefault = 'vi-VN'
      } else if (isTh()) {
        country = 'TH'
        langDefault = 'th-TH'
      } else if (isOS() === true) { // 马来iuopos直接写死马来
        if (rootState.app.system_source === ESG_THACSP_CORE_OS) {
          country = 'TH'
          langDefault = langDefault || 'th-TH'
        } else {
          country = 'MY'
          langDefault = 'en'
        }
      } else {
        // 获取用户ip所在国家，返回对应的国家编码和默认语言编码
        const res = await getSiteCodeApi()
        const data = res.data
        if (!country) {
          country = data.country
        }
        if (!langDefault) {
          langDefault = data.langDefault
        }
      }

      if (isFromTawian() === '1') {
        country = 'TW'
      }

      const siteCountryCode = getUrlKey('siteCountryCode') || ''
      country = siteCountryCode || country
      const lang = getUrlKey('lang') || langDefault || 'zh-CN'
      // lzb 设置导航栏右上角显示的语言
      dispatch('setLanguage', lang)
      // 设置全局语言
      i18n.locale = lang
      // 获取全量的国家区号列表
      dispatch('public/mobileCountries', { country }, { root: true })
      // 根据当前语言获得对应的国家列表
      dispatch('siteList', country)
      // 根据当前语言以及用户所在国家的登录注册配置
      dispatch('siteConfig', { country })
      // 存储用户当前所在的站点编码
      commit('SET_SITE_CODE', country)

      dispatch('getEnabledGeneratorPassword', country)

      // console.log('%c Line:135 🍤', 'color:#33a5ff', 'dispath')
      // dispatch('app/getVerficationCodeStatue', country)
    } catch (error) {
      console.log(error)
    }
  },
  // 获取注册登陆可选国家列表
  async siteList({ commit }, siteCountryCode) {
    try {
      // debugger
      let res = {}
      if (SystemCodeUseNewConfigApi.includes(getUrlKey('sysCode')) || isOS()) {
        res = await separateSiteListApi({ siteCountryCode, sysCode: getUrlKey('sysCode') })
      } else {
        res = await siteListApi({ siteCountryCode, sysCode: getUrlKey('sysCode') })
      }
      commit('SET_SITE_LIST', res.data)
    } catch (error) {
      console.log(error)
    }
  },
  // 本地缓存当前语言的code值
  setLanguage({ rootState, commit, dispatch }, language) {
    // cas 登录方案
    if (rootState.app.system_source) {
      localStorage.removeItem('localLangCode')
    } else {
      localStorage.setItem('localLangCode', language)
    }

    dispatch('app/setSmsTypeDic', {}, { root: true })
    commit('SET_LANGUAGE', language)
  },
  // 设置当前语言的名称
  setLangName({ commit }, list) {
    let langName = ''
    if (list && list.length > 0) {
      list.forEach(el => {
        if (el.lang === state.language) {
          langName = el.langName
        }
      })
    }
    commit('SET_LANG_NAME', langName)
  },
  // 当前站点的配置信息
  async siteConfig({ rootState, commit, dispatch }, params) {
    try {
      // debugger
      if (params.country === 'TW') {
        localStorage.setItem('isFromTainwan', '1')
        // return false
      } else {
        localStorage.setItem('isFromTainwan', '0')
      }

      let res = {}
      if (SystemCodeUseNewConfigApi.includes(getUrlKey('sysCode')) || isOS()) {
        res = await siteConfigSeparateApi({ siteCountryCode: params.country, ...params, lang: store.getters.language, sysCode: rootState.app.system_source || getUrlKey('sysCode') || (isOS() ? 'ICAS_OS' : '') })
      } else {
        res = await siteConfigApi({ siteCountryCode: params.country, ...params })
      }

      const data = res.data
      const { langs, country } = data
      // cas 登录方案
      if (rootState.app.system_source) {
        localStorage.removeItem('localSiteConfig')
      } else {
        localStorage.setItem('localSiteConfig', JSON.stringify(data))
      }

      try {
        if (isOS()) {
          const defaultLang = getUrlKey('lang') || store.getters.language || res.data.langDefault.lang
          i18n.locale = defaultLang
        }
      } catch (error) {
        /* empyt */
      }

      if (!isOS()) {
        const { data: extendData } = await siteConfigExtend({ sysCode: rootState.app.system_source || getUrlKey('sysCode') || 'IBU-ICAS-CORE' })
        commit('SET_SITE_CONFIG', {
          ...data,
          ...extendData
        })
      } else {
        commit('SET_SITE_CONFIG', {
          ...data,
        })
      }

      dispatch('setLangName', langs)

      commit('SET_SITE_CODE', country)
      commit('SET_SITE_CONFIG_DONE', true)
      dispatch('app/getVerficationCodeStatue', country, { root: true })
    } catch (error) {
      // 如果获取的国家配置被禁用了或者其他报错，重新走获取根据ip获取所在国家拉取相关配置
      dispatch('siteCode')
      console.log(error)
    }
  },
  async getRegexpRemote({ commit }) {
    const response = await getDictionaryApi({ name: 'pattern', key: 'login', lang: 'en' })
    let emailReg = '^\\w+((-\\w*)|(\\.\\w+)|(\\+\\w*))*\\@[A-Za-z0-9_]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$'
    if ((response?.data && response.data.email)) {
      emailReg = response?.data?.email
    }
    commit(
      'SET_REGEXP_REMOTE',
      {
        email: emailReg,
      }
    )
  },
  async getShowMessageNotice({ commit }) {
    const response = await getDictionaryApi({ name: 'message_notice', key: 'message_notice_switch', lang: 'zh-CN' })
    commit('SET_MESSAGE_NOTICE_SHOW', response?.data?.message_notice_switch === '1' || false)
  },
  async getEnabledGeneratorPassword({ commit }, country) {
    const resText = await getDictionaryApi(
      { name: 'enable_generated_password', key: 'country' },
      { customedHeaderLang: 'en' }
    )
    // const res = resText?.data?.country?.split(',')?.includes(country) || false
    commit('SET_GENERATED_PASSWORD_ENABLED', resText?.data?.country?.split(',') || [])
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

